module.exports = __webpack_public_path__ + "static/img/banner-bg.75305605.png";